import type { QueryClickActionsMode } from "../../types";

export const MetabotMode: QueryClickActionsMode = {
  name: "public",
  clickActions: [],
};
